import { render, staticRenderFns } from "./preRegistPage.vue?vue&type=template&id=e0b3af96&scoped=true&"
import script from "./preRegistPage.vue?vue&type=script&lang=js&"
export * from "./preRegistPage.vue?vue&type=script&lang=js&"
import style0 from "./preRegistPage.vue?vue&type=style&index=0&id=e0b3af96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b3af96",
  null
  
)

export default component.exports